export default __webpack_public_path__ + "static/depooter-d6e20b1093d6151182a7d6bb1b03adfb.png";